import clsx from "clsx";
import React from "react";

type Props = {
  active?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
};

export default function Badge({ active, onClick, children }: Props) {
  return (
    <div
      className={clsx([
        "border rounded-full py-1 px-3 cursor-pointer",
        {
          "bg-brand-primary-magenta text-white font-semibold border-brand-primary-magenta":
            active,
          "border-brand-gray-10 border-opacity-10 text-brand-neutral-40":
            !active,
        },
      ])}
      onClick={() => onClick?.()}
    >
      {children}
    </div>
  );
}
